import React, { useContext } from 'react';
import { Context } from '../../../context/AppContext';
import { MODALS } from '../../../constants';
import './styles.css';

const HeaderSearch = ({ searchKeyword, searchLocation }) => {
  const {
    modal: { showModal },
  } = useContext(Context);

  return (
    <div className="Listview__HeaderSearch">
      <div className="Listview__HeaderSearch__input">
        <button
          className="Listview__HeaderSearch__location"
          onClick={() =>
            showModal(MODALS.SEARCH_AUTOSUGGEST, {
              inputFocus: 'keyword',
              keywordPlaceholder: searchKeyword,
            })
          }
        >
          <i className="icon-generalsearchlarge" />{' '}
          <span>
            {searchKeyword} in {searchLocation}
          </span>
        </button>
        <button
          className="Listview__HeaderSearch__filters"
          onClick={() => showModal(MODALS.FILTERS_MOBILE)}
        >
          <i className="icon-generalrefine" /> Filters
        </button>
      </div>
    </div>
  );
};

export default HeaderSearch;
